module.exports = __webpack_public_path__ + "assets/loading.83bd46cc.svg";